import {Component, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {TtsControlEnum} from '@core/enums/tts-control.enum';
import {PlayAudioService} from '@shared/utils/play-audio.service';
import {KeycloakApplicationRolesEnum} from '@core/modules/rest/user/enums/keycloak-application-roles.enum';
import {Observable} from 'rxjs';
import {LoggedUserDataModel} from '@core/modules/rest/user/response/logged-user-data.model';
import {CoreReducer} from '@core/store';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {Store} from '@ngrx/store';
import {AppState} from '@core/reducers';
@UntilDestroy()
@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'app-abstract-dialog',
    templateUrl: './abstract-dialog.component.html',
    styleUrls: ['./abstract-dialog.component.scss']
})

export class AbstractDialogComponent implements OnChanges {
    @Input() dialogWidth: '600' | '700' | '800' | 'auto' | undefined;
    @Input() ttsIconState: TtsControlEnum | undefined;
    @Input() playButtonActive = false;
    @Input() repeatButtonActive = false;
    @Input() paddingOff: boolean | undefined;
    @Input() showCloseButton = true;
    @Input() showVoiceControls = true;
    @Output() readTextEvent: EventEmitter<any> = new EventEmitter();
    @Output() playAudioEvent: EventEmitter<any> = new EventEmitter();
    @Output() closeEvent: EventEmitter<any> = new EventEmitter();

    allRoles: KeycloakApplicationRolesEnum[] = [];
    loggedUserInfo$: Observable<LoggedUserDataModel> = this.store.select(CoreReducer.loggedUserDataSelector);
    patientRole = false;

    defaultIconState = TtsControlEnum.playState;

    constructor(private playService: PlayAudioService, private dialog: MatDialogRef<AbstractDialogComponent>, private store: Store<AppState>) {
    }

    @HostListener('keyup.tab', ['$event.target'])
    @HostListener('keyup.shift.tab', ['$event.target'])
    onTab(target): void {
        const textForReading = target.getAttribute('aria-label');
        this.playService.readCommands(textForReading);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.loggedUserInfo$.pipe(untilDestroyed(this))
            .subscribe((loggedUserData: LoggedUserDataModel) => {
                this.allRoles = loggedUserData.roles;
                if (this.allRoles.includes(KeycloakApplicationRolesEnum.PATIENT)) {
                    this.patientRole = true;
                }
            });
    }

    close(): void {
        this.closeEvent.emit();
        this.dialog.close();
    }

    readText(): void {
        this.readTextEvent.emit();
    }

    playAudio(): void {
        this.playAudioEvent.emit();
    }
}
